import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TransactionsList = ({ transactions, onDelete }) => {
  const categoryIcons = {
    membership: 'Users',
    class: 'Calendar',
    personal_training: 'Dumbbell',
    merchandise: 'ShoppingBag',
    other: 'MoreHorizontal'
  };

  const categoryColors = {
    membership: 'text-blue-500 bg-blue-500/10',
    class: 'text-green-500 bg-green-500/10',
    personal_training: 'text-purple-500 bg-purple-500/10',
    merchandise: 'text-orange-500 bg-orange-500/10',
    other: 'text-gray-500 bg-gray-500/10'
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const formatCategory = (category) => {
    return category?.split('_')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
  };

  if (!transactions || transactions?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-md p-12 text-center">
        <Icon name="Receipt" size={64} className="text-muted-foreground mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-foreground mb-2">No transactions found</h3>
        <p className="text-muted-foreground">
          Add your first transaction to start tracking revenue
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl shadow-md overflow-hidden">
      <div className="p-6 border-b border-border">
        <h2 className="text-lg font-semibold text-foreground">Recent Transactions</h2>
      </div>

      {/* Desktop Table View */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-accent/50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Date
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Category
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Description
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Amount
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {transactions?.map((transaction) => (
              <tr key={transaction?.id} className="hover:bg-accent/30 transition-smooth">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground">
                  {formatDate(transaction?.transaction_date)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full ${
                    categoryColors?.[transaction?.category]
                  }`}>
                    <Icon name={categoryIcons?.[transaction?.category]} size={14} />
                    <span className="text-xs font-medium">
                      {formatCategory(transaction?.category)}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 text-sm text-foreground">
                  {transaction?.description || 'No description'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-semibold text-success">
                  ${parseFloat(transaction?.amount)?.toFixed(2)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onDelete(transaction?.id)}
                    className="text-destructive hover:text-destructive"
                  >
                    <Icon name="Trash2" size={16} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card View */}
      <div className="md:hidden divide-y divide-border">
        {transactions?.map((transaction) => (
          <div key={transaction?.id} className="p-4">
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center gap-2">
                <div className={`flex items-center justify-center w-10 h-10 rounded-lg ${
                  categoryColors?.[transaction?.category]
                }`}>
                  <Icon name={categoryIcons?.[transaction?.category]} size={20} />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground">
                    {formatCategory(transaction?.category)}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {formatDate(transaction?.transaction_date)}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-lg font-bold text-success">
                  ${parseFloat(transaction?.amount)?.toFixed(2)}
                </p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-2">
              {transaction?.description || 'No description'}
            </p>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDelete(transaction?.id)}
              className="text-destructive hover:text-destructive w-full"
            >
              <Icon name="Trash2" size={16} className="mr-2" />
              Delete
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TransactionsList;